module.exports = "/_next/static/images/wallet-9e032e2d399111b9d487fa36caf009ba.svg";